import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NotFound from "./components/Common/NotFound";
import { routeConfig } from "./container/routeConfig";
import axios from "axios";
import { getUserToken } from "./config/user";

function App() {
  const token = getUserToken();
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  axios.defaults.headers.common["Content-Type"] = "application/json";
  console.log(getUserToken())
  return (
    <Router>
      <Routes>
        {routeConfig.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
export default App;
